import styled from '@emotion/styled';
import { fontSizes } from 'app/typography';
import css from '@emotion/css';

export const BulkActionInfoWrapper = styled.div<{
  marginBottom?: boolean;
  noLeftPadding?: boolean;
  backgroundColor?: string;
}>`
  display: flex;
  flex-direction: column;
  gap: 15px;
  background: ${({ backgroundColor }) =>
    backgroundColor || 'var(--color-feedback-info-bg)'};
  border-radius: 4px;
  margin-top: 17px;
  padding: ${({ noLeftPadding }) =>
    noLeftPadding ? css`10px 10px 6px 0` : css`10px 10px 6px`};
  ${({ marginBottom = false }) =>
    marginBottom &&
    css`
      margin-bottom: 20px;
    `};
`;

export const BulkActionTextWrapper = styled.div<{ marginBottom?: boolean }>`
  span {
    line-height: 110%;
  }

  .field-value {
    white-space: break-spaces;
    word-break: break-all;
    font-size: ${fontSizes.micro};
  }
  ${({ marginBottom }) =>
    marginBottom &&
    css`
      margin-bottom: 13px;
    `}
`;

export const Wrapper = styled.div`
  width: 100%;
`;
